import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
export type AttachedFileFragment = { __typename?: 'AttachedFile', context: string, createdAt: string, cleanedId?: number | null, downloadUrl?: string | null, id: string, isCleaned: boolean, isStp?: boolean | null, largeUrl?: string | null, name: string, parentId?: number | null, uid: string, updatedAt: string, url?: string | null, mediumUrl?: string | null, preview?: string | null, previewPriority: number, description?: string | null };

export const AttachedFileFragmentDoc = gql`
    fragment attachedFile on AttachedFile {
  context
  createdAt
  cleanedId
  downloadUrl
  id
  isCleaned
  isStp
  largeUrl
  name
  parentId
  uid
  updatedAt
  url
  mediumUrl
  preview
  previewPriority
  description
}
    `;